<template>
    <div class="projects-map">
        <div id="projects-map-canvas" ref="map"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Loader } from '@googlemaps/js-api-loader'

export default {
    name: 'ProjectsMap',

    mounted () {
        this.init()
    },

    computed: {
        ...mapState({
            projects: state => state.projects
        })
    },

    activated () {
        this.init()
    },

    data () {
        return {
            map: null,
            zoom: 10,
            center: {lat: 51.33537, lng: 7.04348},
            markers: [],
            bounds: null
        }
    },

    methods: {
        async init () {
            this.blockGoogleFont()

            // eslint-disable-next-line
            const loader = new Loader({
                apiKey: 'AIzaSyBixNoO1ZBQ67qHN1jzJZU8AlPwWQgtFCc',
                version: 'beta',
                libraries: ['marker'],
            })

            const google = await loader.load()

            this.map = new google.maps.Map(this.$refs.map, {
                zoom: this.zoom,
                center: this.center,
                mapId: 'DEMO_MAP_ID'
            })

            this.initBounds()
            this.initMarkers()
            this.fitBounds()

            // assign router helper to window so we can trigger the router from window
            window.openProject = (id) => {
                this.$router.push({name: 'PageDetail', params: {id}})
            }
        },

        initBounds () {
            // eslint-disable-next-line
            this.bounds = new google.maps.LatLngBounds()
        },

        initMarkers () {
            this.markers = this.projects
                .filter(project => project.lat && project.lng)
                .map(project => {
                // Create position
                    const position = this.createPosition(project.lat, project.lng)
                    // Create marker
                    // eslint-disable-next-line
                const marker = new google.maps.marker.AdvancedMarkerElement({
                        position,
                        map: this.map,
                        title: project.titel
                    })
                    // eslint-disable-next-line
                const window = new google.maps.InfoWindow({
                        content: `<div class="infowindow">
                                    <h3>${project.titel}</h3>
                                    <p>${project.logkurzbeschreibungo}</p>
                                    <a class="btn btn--blue" style="color: #fff;" onclick="openProject(${project.id});">Zum Projekt</a>
                                </div>`,
                        maxWidth: 400
                    })
                    // Listen to clicks
                    marker.addListener('click', event => {
                    // Navigate to project
                    // this.$router.push({name: 'PageDetail', params: {id: project.id}})
                        window.open(this.map, marker)
                    })
                    // Extend map boundaries
                    this.bounds.extend(position)
                    // reurn the marker
                    return marker
                })
        },

        fitBounds () {
            this.map.fitBounds(this.bounds)
        },

        createPosition (lat, lng) {
            lat = parseFloat(lat)
            lng = parseFloat(lng)
            return {lat, lng}
        },

        blockGoogleFont () {
            const head = document.head
            const insertBefore = head.insertBefore
            head.insertBefore = (newElement, referenceElement) => {
                if (newElement instanceof Element && newElement.hasAttribute('href') && newElement.getAttribute('href').includes('fonts.googleapis')) {
                    return newElement
                }
                insertBefore.call(head, newElement, referenceElement)
                return newElement
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectsMap.vue